import type { GeometryGeneratorId } from '../services/dajiaoService';

/** GT = geom-type；NGT = non-geom-type */
export type EmbedImageKind = 'GT' | 'NGT';

export const EMBED_IMAGE_KIND_META_KEY = 'relatedGraphEmbedImageKind';
export const EMBED_IMAGE_CLASSIFIER_META_KEY = 'relatedGraphEmbedImageClassifier';

/** GT：大角·Qwen Agent 置顶，其后保留 NGT 清脏备选便于对照 */
export const MODEL_ORDER_GT: GeometryGeneratorId[] = [
  'dajiao-qwen-agent',
  'qwen-image-3.0-pro',
  'gpt-image-2',
];

/** NGT：Pro → Image2（价质对照；qwen-image-3.0 标准档已下线隐藏） */
export const MODEL_ORDER_NGT: GeometryGeneratorId[] = [
  'qwen-image-3.0-pro',
  'gpt-image-2',
];

export const VENDOR_KIND_BY_ID: Record<GeometryGeneratorId, EmbedImageKind> = {
  'dajiao-qwen-agent': 'GT',
  dajiao: 'GT',
  'gpt-image-2': 'NGT',
  'qwen-image-3.0': 'NGT',
  'qwen-image-3.0-pro': 'NGT',
};

export function resolveModelOrder(kind: EmbedImageKind | null | undefined): GeometryGeneratorId[] {
  return kind === 'NGT' ? [...MODEL_ORDER_NGT] : [...MODEL_ORDER_GT];
}

export function readParticleEmbedImageKind(
  metadata: Record<string, unknown> | null | undefined,
): EmbedImageKind | null {
  const raw = String(metadata?.[EMBED_IMAGE_KIND_META_KEY] || '').trim().toUpperCase();
  if (raw === 'GT' || raw === 'NGT') return raw;
  return null;
}
